import { CHAT_SESSION_STORE_KEY, DRAFT_CONTEXT_KEY } from "./chatSessionCache";
import { INSTRUCTION_STORE_KEY, PROPERTY_CONTEXT_STORE_KEY } from "./contextCache";

// Marks which Outlook process the persisted caches belong to.
const SESSION_MARKER_KEY = "outlookStorageSession";

// Per-message caches that should live only for the current Outlook session.
// Auth (`authState`) and one-time UI flags are intentionally excluded so the
// user stays logged in across restarts.
const SESSION_SCOPED_KEYS = [
  CHAT_SESSION_STORE_KEY,
  PROPERTY_CONTEXT_STORE_KEY,
  INSTRUCTION_STORE_KEY,
  DRAFT_CONTEXT_KEY,
];

/**
 * VSTO passes a unique `session` id per Outlook process. When that id changes
 * (i.e. Outlook was restarted) we drop the session-scoped caches so local
 * storage cannot grow without bound. All panes in the same Outlook run share
 * the id, so cross-pane reply propagation is preserved within a session.
 *
 * No-op when there is no `session` param (e.g. the Office web add-in), leaving
 * that storage behavior unchanged.
 */
export const enforceSessionStorageScope = () => {
  try {
    const sessionId = new URLSearchParams(window.location.search).get("session");
    if (!sessionId) {
      return;
    }

    if (localStorage.getItem(SESSION_MARKER_KEY) === sessionId) {
      return;
    }

    SESSION_SCOPED_KEYS.forEach((key) => {
      try {
        localStorage.removeItem(key);
      } catch {
        // ignore individual key failures
      }
    });

    localStorage.setItem(SESSION_MARKER_KEY, sessionId);
  } catch {
    // storage unavailable — nothing to clear
  }
};
